/***
 *
 *   STAGE ICON
 *   The five workflow stages, with their display names, one-liners and
 *   glyphs (same paths as the site's workflow-icons). The first stage shows
 *   as "Intake"; its slug stays "collect", the key the server's view model
 *   and the [data-wf] styles use. Glyphs are 24x24,
 *   stroke 1.5, square caps and miter joins, coloured by currentColor, which
 *   the [data-wf] mapping in workflow.module.scss sets per stage.
 *
 *   "start" and "written" are the Starts and Written back column marks.
 *
 **********/

import React from "react";
import styles from "./workflow.module.scss";
import { cx } from "./details";

export const STAGES = [
  { slug: "collect", name: "Intake", line: "Start every client from one link" },
  { slug: "verify", name: "Verify", line: "Confirm they are who they say" },
  { slug: "screen", name: "Screen", line: "PEP/Sanctions and adverse media" },
  { slug: "assess", name: "Assess", line: "A defensible risk rating" },
  { slug: "monitor", name: "Monitor", line: "Keep verified clients current" },
];

const GLYPHS = {
  collect: (
    <>
      <path d="M9 2h6a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2Z" />
      <path d="M7 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2" />
      <path d="M9 12h6M9 16h4" />
    </>
  ),
  verify: (
    <>
      <path d="M12 3 4 6v6c0 4.5 3.2 7.3 8 9 4.8-1.7 8-4.5 8-9V6l-8-3Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  screen: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </>
  ),
  assess: <path d="M12 20V10M6 20v-4M18 20V4" />,
  monitor: (
    <>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  start: <path d="M5 12h14M13 6l6 6-6 6" />,
  written: <path d="M4 12l5 5L20 6" />,
};

export function stageName(slug) {
  return STAGES.find((s) => s.slug === slug)?.name || "";
}

/* the glyph in its tinted tile; `large` is the drawer's 38px size */
export function StageIcon({ name, large }) {
  const glyph = GLYPHS[name];
  if (!glyph) return null;

  return (
    <span
      className={cx(styles.ico, large && styles.icoL, name === "written" && styles.okIco)}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="miter"
        focusable="false"
      >
        {glyph}
      </svg>
    </span>
  );
}
